// extracted by mini-css-extract-plugin
module.exports = {"personalGroupList":"UIGroupUserItem_personalGroupList__LvaL6","imgShareGroup":"UIGroupUserItem_imgShareGroup__3XpQ7","imgShare":"UIGroupUserItem_imgShare__3c5eJ"};